import clsx from 'clsx';
import { observer } from 'mobx-react';
import { translation, TranslationsContext } from '../../../../Translations';
import ParticipantsV2Store from '../Store';

interface Props {
  store: ParticipantsV2Store;
  page: number;
  current: number;
}

const goToPage = (store: ParticipantsV2Store) => (page: number) => () => store.goToPage(page);

function PageButton({ store, page, current }: Props) {
  const isCurrent = page === current;

  return (
    <TranslationsContext.Consumer>
      {(ts) => (
        <button
          type="button"
          onClick={goToPage(store)(page)}
          aria-current={isCurrent ? 'page' : undefined}
          aria-label={translation('Go to page {{page}}', { page })(ts)}
          className={clsx(
            'min-w-[2.25rem] rounded-md border px-3 py-1.5 tabular-nums transition-colors focus:outline-none focus:ring-2 focus:ring-ring',
            isCurrent
              ? 'border-primary text-primary'
              : 'border-transparent text-foreground hover:bg-muted',
          )}
          style={{ fontSize: 'var(--text-sm)' }}
          data-intercom-target="people-v2-pagination-page-button"
        >
          {page}
        </button>
      )}
    </TranslationsContext.Consumer>
  );
}

export default observer(PageButton);
